/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RatingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Tebuto reviews
     * @returns any Tebuto reviews from Google, updated every 24 hours
     * @throws ApiError
     */
    public getReviews(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rating/reviews',
        });
    }
    /**
     * Get Tebuto rating
     * @returns any Tebuto rating from Google, updated every 24 hours
     * @throws ApiError
     */
    public getRating(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rating',
        });
    }
}
